import gsap from "gsap";
import { module as BaseModule } from "modujs";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default class extends BaseModule {
  init() {
    const slider = this.el
    const { sliderConfig } = slider.dataset

    const params = {
      default: {
        modules: [Navigation, Pagination ],
        navigation: {
          nextEl: '[data-module-slider-next]',
          prevEl: '[data-module-slider-prev]',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        grabCursor: true,
        slidesPerView: 1,
        loop: true,
      },
    }

    this.swiper = new Swiper(slider, params[sliderConfig])
    gsap.to(slider, {
      opacity: 1,
      duration: 3,
      ease: "power2.Out",
    })
  }
}
